const BASIC = [
  "きゃ", "きゅ", "きょ", "しゃ", 
  "しゅ", "しょ", "ちゃ", "ちゅ", "ちょ", 
  "にゃ", "にゅ", "にょ", "ひゃ", "ひゅ", 
  "ひょ", "みゃ", "みゅ", "みょ", "りゃ", 
  "りゅ", "りょ", "ぎゃ", "ぎゅ", "ぎょ", 
  "じゃ", "じゅ", "じょ", "びゃ", "びゅ", 
  "びょ", "ぴゃ", "ぴゅ", "ぴょ",
  "あ", "い", "う", "え", "お", 
  "か", "き", "く", "け", "こ", 
  "さ", "し", "す", "せ", "そ", 
  "た", "ち", "つ", "て", "と", 
  "な", "に", "ぬ", "ね", "の", 
  "は", "ひ", "ふ", "へ", "ほ", 
  "ま", "み", "む", "め", "も", 
  "や", "ゆ", "よ", "ら", "り", 
  "る", "れ", "ろ", "わ", "を", "ん",
]

export default BASIC;